import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'help_center-retailer_card-click';

/**
 * Retailer card on click event under the HomeHeader section
 */
export function trackHelpCenterRetailerCardClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
